import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, isRef as _isRef, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import {ref} from "vue";
import {useRoute} from "vue-router";
import config from "@/config.json";
import {Item} from "@/types/Item";


export default /*#__PURE__*/_defineComponent({
  __name: 'DeleteItem',
  props: {
    item: {}
  },
  emits: ['delete'],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emit = __emit
const route = useRoute()
let dialog = ref(false)
let loading = ref(false)
let item: Item = props.item

async function deleteItem() {
  loading.value = true;
  let name = encodeURIComponent(item.name)
  let response = await fetch(`${config.API}/private/guilds/${route.params.id}/items/${name}`, {
    method: 'DELETE',
    headers: {
      Authorization: localStorage.getItem('token') as string
    }
  })
  if (response.ok) {
    dialog.value = false;
    emit('delete', item)
  }
  loading.value = false;
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_btn, {
      icon: "",
      variant: "text",
      size: "small",
      color: "red",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_isRef(dialog) //@ts-ignore
 ? dialog.value = true : dialog = true))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_icon, { size: "25" }, {
          default: _withCtx(() => [
            _createTextVNode("delete")
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_dialog, {
      modelValue: _unref(dialog),
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(dialog) ? (dialog).value = $event : dialog = $event)),
      width: "500px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, { color: "modal" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, { class: "modal-header" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('Items.subtitles.deleteItem')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_text, {
              innerHTML: _ctx.$t('Items.subtitles.deleteConfirm').replace('[I]',
        `<code>${_unref(item).name}</code>`)
            }, null, 8, ["innerHTML"]),
            _createVNode(_component_v_divider),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_btn, {
                  color: "red",
                  loading: _unref(loading),
                  text: "",
                  onClick: deleteItem
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('Items.subtitles.delete')), 1)
                  ]),
                  _: 1
                }, 8, ["loading"]),
                _createVNode(_component_v_btn, {
                  text: "",
                  disabled: _unref(loading),
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_isRef(dialog) //@ts-ignore
 ? dialog.value = false : dialog = false))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('Items.subtitles.cancel')), 1)
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})